export const PERSONAL_SETTINGS_KEYS = {
    theme: 'theme',
    homeDashboardId: 'HomeDashboardId',
};
